import { CanvasAnimatedTile } from 'themes/canvas/components/CanvasAnimatedTile';
import { CanvasFooterReviews } from 'themes/canvas/components/FooterReviews/CanvasFooterReviews';
import { Marquee } from 'themes/canvas/components/Marquee/Marquee';
import { CanvasTeamSection } from 'themes/canvas/components/TeamSection/CanvasTeamSection';

import { Heading } from 'components/Heading';

import { useAboutPage } from 'hooks/page/about/useAboutPage';
import { useHomePage } from 'hooks/page/home/useHomePage';
import { useTeamPage } from 'hooks/page/team/useTeamPage';

import { TService } from 'types/service';

import s from './CanvasTeam.module.css';

export const CanvasTeam = () => {
  // TODO - Please let me know if having multiple page hooks on any page is a bad pattern
  const { professionals, handleBook } = useTeamPage();
  const { services } = useHomePage();
  const { aboutText } = useAboutPage();

  const items = services.map((service: TService) => service.name);

  return (
    <>
      <main className={s.teamMain}>
        <section className={s.header}>
          <CanvasAnimatedTile>
            <Heading as="h2" variant="large">
              OUR TEAM
            </Heading>
            <p>{aboutText}</p>
          </CanvasAnimatedTile>
        </section>
        <section className={s.container}>
          <CanvasTeamSection
            handleBook={handleBook}
            professionals={professionals}
            staggerColumns={true}
          />
        </section>
      </main>
      <div className={s.marquee}>
        <Marquee items={items} />
      </div>
      <section>
        <CanvasFooterReviews />
      </section>
    </>
  );
};
